import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import type { CSSProperties } from 'react';
import { instHotspotThemeCardStyle } from './Config';

export function InstHotspotMetricLabel({
  label,
  tooltip,
  style,
}: {
  label: string;
  tooltip: string;
  style?: CSSProperties;
}) {
  return (
    <span className="lf-inst-hotspot-theme-metric-label" style={style}>
      {label}
      <Tooltip title={tooltip} trigger={['hover', 'click']}>
        <span
          className="lf-inst-hotspot-metric-help"
          role="button"
          tabIndex={0}
          aria-label={tooltip}
          style={{
            fontSize: instHotspotThemeCardStyle.metricHelpIconSize,
            color: instHotspotThemeCardStyle.metricHelpIconColor,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <QuestionCircleOutlined />
        </span>
      </Tooltip>
    </span>
  );
}
